import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import PdfFile from './PdfFile'
import { PDFDownloadLink, PDFViewer, StyleSheet } from '@react-pdf/renderer';
import axios from 'axios'
import { useEffect } from 'react';
import Loader from './Loader';
import { Slide, Snackbar } from '@mui/material';
const UserDataUrl = "https://oaucvbuilder.onrender.com/cv/fetchUserData"

function CvReview() {
  const navigate = useNavigate();
  const [docLoading, setDocloading] = useState(true);
  // const { auth } = useAuth();
  const auth = JSON.parse(localStorage.getItem("auth"));
  const [userInfo, setUserInfo] = useState({});

  const styles = StyleSheet.create({
      viewer: {
        width: "100%",
        height: window.innerHeight,
      }
    });

  
  useEffect(() => {
    const getDataInfo = async () =>{
      try {
        const response = await axios.get(UserDataUrl,
        {
          headers:{
            Authorization: auth.token
          }
        });
        console.log(response);
        setUserInfo(response?.data?.detail);
        setDocloading(false);
      } catch (error) {
        console.log(error)
        if (error.response.status === 400){
          setShowSnackBar(true);
        }
      }
    }
    getDataInfo();
  }, [])
  
  const [showSnackBar, setShowSnackBar] = useState(false);

  const closeSnackBar = (event, reason) =>{
    if (reason === 'clickaway') {
      return;
    }
    setShowSnackBar(false);
    navigate("/login");
  }
  function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
  }


  // console.log(userInfo);
  
  return (
    <div className='relative '>
      <Snackbar
            open={showSnackBar}
            autoHideDuration={4000}
            onClose={closeSnackBar}
            TransitionComponent={TransitionLeft}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            ContentProps={{
              sx: {
                background: "#3e4095"
              }
            }}
            message="Session Expired! Redirecting to Login..."
            // action={action}
      />
      {docLoading && <Loader />}
      <div className='h-full w-full py-8'>
        <div className='w-11/12 mx-auto flex flex-col gap-6 lg:w-8/12 pt-12 pb-10 sm:pt-14 md:px-14 md:shadow-lg'>
          <div className='space-y-5'>
            <h1 className='text-custom-blue font-bold text-2xl lg:text-3xl'>Congratulations</h1>
            <p className='text-custom-brown text-base lg:text-lg'>Great job on completing your CV using the OAU CV building application! 
              Preparing your CV is an important step, and having a well-organized and comprehensive CV will give you a significant advantage. 
              Keep up the good work, and best of luck!"
            </p>
            <p className='text-base text-gray-500'>
              Below is a preview of the generated CV, ensure all details are correctly displayed before downloading
            </p>
            <div className='my-5 w-full border'>
              <PDFViewer showToolbar={false} style={styles.viewer}>
                <PdfFile userInfo={userInfo} />
              </PDFViewer>
              
            </div>
          </div>
          <div className='flex flex-col gap-8 box-border w-full text-custom-brown text-base'>
            <p className='text-custom-brown text-base lg:text-lg'>
              You can edit or download your cv by clicking the buttons below.
            </p>
            <div className='flex flex-row  justify-between'>
              <Link to="/create-cv"><p className='py-4 w-[170px] text-center text-white font-medium text-base lg:text-lg rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer'>Edit CV</p></Link>
              <PDFDownloadLink document={<PdfFile userInfo={userInfo} />} fileName={userInfo?.users?.surname+"'s CV.pdf"} className='py-4 w-[170px] text-center text-white font-medium text-base lg:text-lg rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer'>
                {/* <p className='py-4 w-[170px] text-center text-white font-medium text-base lg:text-lg rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer'>
                  Download CV
                </p> */}
                {({ blob, url, loading, error }) =>
                  loading ? "Loading..." :  "Download CV"
                  }
                  {/* Download CV */}
                {/* {({ blob, url, loading, error }) => (loading ? setDocloading(true) : setDocloading(false))} */}
              </PDFDownloadLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CvReview